<template>
  <div class="card">
    <div class="card-header">
      <h6>Test Overview</h6>
    </div>
    <div class="card-body row">
      <div class="col-6">Tanggal</div>
      <div class="col-6">{{ data.online_test.created_at }}</div>

      <div class="col-6">Nilai</div>
      <div class="col-6">{{ data.online_test.score }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data',],
}
</script>
